// Changelog pubblico mostrato nel modal "Novità versione".
// Regole:
// - La prima entry è la versione CORRENTE (quella mostrata in sidebar).
// - Bump della versione ad ogni redeploy con cambiamenti user-facing.
// - `icon` è il nome di un'icona lucide-react (vedi WhatsNewModal.js per mapping).
// - `text` deve essere in italiano, chiaro e benefit-oriented (niente gergo tecnico).

export const APP_VERSION = '1.9.0';

export const CHANGELOG = [
  {
    version: '1.9.0',
    date: '10 Giugno 2026',
    title: 'Prova gratuita della fatturazione elettronica',
    highlights: [
      { icon: 'Sparkles', text: 'Dalla sezione "Fatture" puoi attivare una prova gratuita di 7 giorni della fatturazione elettronica. Finita la prova la funzione è a pagamento: chiedi all\'amministratore di attivarla.' },
      { icon: 'Bell', text: 'Nuovo avviso al login con le novità sul canone e sulla fatturazione: clicca "Accetta" per non vederlo più, oppure "Ricordamelo dopo".' },
    ],
  },
  {
    version: '1.8.0',
    date: '10 Giugno 2026',
    title: 'Fatture elettroniche',
    highlights: [
      { icon: 'FileSpreadsheet', text: 'Nuova sezione "Fatture": crea una fattura differita raggruppando i DDT di un cliente, oppure una fattura libera da zero. L\'IVA viene scorporata dai prezzi, prodotto per prodotto.' },
      { icon: 'Send', text: 'Collega il tuo account Aruba Fatturazione Elettronica in Impostazioni e invia le fatture allo SDI con un click; poi segui lo stato (consegnata, scartata...) direttamente dall\'app.' },
      { icon: 'Eye', text: 'Per ogni fattura puoi scaricare il file XML e il PDF di cortesia. Nei clienti trovi i nuovi campi Codice Destinatario, PEC, Codice Fiscale e Provincia.' },
    ],
  },
  {
    version: '1.7.0',
    date: '10 Giugno 2026',
    title: 'Prezzi personalizzati per cliente',
    highlights: [
      { icon: 'Sparkles', text: 'L\'app ora ricorda l\'ultimo prezzo a cui hai venduto ogni prodotto a ciascun cliente e lo precompila automaticamente nei nuovi DDT (con il prezzo di listino visibile accanto).' },
      { icon: 'Wallet', text: 'Se cambi cliente su un DDT già compilato, i prezzi delle righe si aggiornano da soli con lo storico del nuovo cliente.' },
      { icon: 'Eye', text: 'Nella pagina Clienti, l\'icona etichetta mostra l\'elenco dei prezzi memorizzati per quel cliente, con la possibilità di eliminarli.' },
    ],
  },
  {
    version: '1.6.4',
    date: '04 Febbraio 2026',
    title: 'Fix definitivo "mi sloggava dopo poco"',
    highlights: [
      { icon: 'ShieldCheck', text: 'Risolto il bug per cui dopo circa 15 minuti l\'app ti chiedeva di rifare login senza motivo: ora resti collegato per 30 giorni filati finché usi l\'app.' },
    ],
  },
  {
    version: '1.6.3',
    date: '04 Febbraio 2026',
    title: 'Pagina DDT più pulita',
    highlights: [
      { icon: 'Sparkles', text: 'Rimosso il vecchio pulsante "Invia ad azienda" dalla pagina DDT: non serve più perché il DDT viene offerto in invio automatico subito dopo il salvataggio quando il cliente ha la stessa Partita IVA di un\'azienda registrata.' },
    ],
  },
  {
    version: '1.6.2',
    date: '04 Febbraio 2026',
    title: 'Vedi, scarica e stampa i DDT ricevuti',
    highlights: [
      { icon: 'Eye',    text: 'Nell\'Inbox DDT ora puoi aprire un\'anteprima in sola lettura di ogni documento ricevuto, prima di accettarlo o rifiutarlo.' },
      { icon: 'FileSpreadsheet', text: 'Un click sul PDF apre il documento in una nuova scheda: da lì puoi stamparlo o scaricarlo. Il DDT ricevuto non è modificabile — resta esattamente come è stato inviato.' },
    ],
  },
  {
    version: '1.6.1',
    date: '04 Febbraio 2026',
    title: 'Niente più logout a sorpresa dopo un aggiornamento',
    highlights: [
      { icon: 'ShieldCheck', text: 'Risolto il problema per cui dopo un nuovo aggiornamento dell\'app venivi riportato alla schermata di login al primo click.' },
      { icon: 'Rocket',      text: 'Quando esce una nuova versione mentre stai usando l\'app, ricevi un avviso con il pulsante "Aggiorna ora" invece di essere disconnesso.' },
    ],
  },
  {
    version: '1.6.0',
    date: '04 Febbraio 2026',
    title: 'Inbox più in vista + Invio automatico DDT',
    highlights: [
      { icon: 'Inbox',  text: '"Inbox DDT" ora è in alto nel menu, subito dopo la Dashboard: lo vedi subito appena entri.' },
      { icon: 'Bell',   text: 'Suono di notifica quando arriva un nuovo DDT in attesa, anche con l\'app aperta in un\'altra scheda.' },
      { icon: 'Send',   text: 'Dopo aver salvato un DDT, se la Partita IVA del cliente coincide con un\'azienda registrata su DDT Manager, ti chiediamo con un click se vuoi inviarglielo subito.' },
    ],
  },
  {
    version: '1.5.0',
    date: '04 Febbraio 2026',
    title: 'Promemoria rinnovo + Inbox più chiaro',
    highlights: [
      { icon: 'Bell',          text: 'Pallino rosso con il numero di DDT ricevuti ancora da approvare, accanto a "Inbox DDT" nel menu laterale.' },
      { icon: 'AlertTriangle', text: 'Avviso in-app sul rinnovo abbonamento (200 € → 400 €), in italiano e arabo, chiudibile con "Ricordamelo domani" o "Non per 7 giorni".' },
      { icon: 'Sparkles',      text: 'Nuova finestra "Novità versione": ogni volta che aggiorniamo l\'app vedrai subito cosa è cambiato.' },
    ],
  },
  {
    version: '1.4.0',
    date: '28 Gennaio 2026',
    title: 'Inbox cross-azienda + App installabile',
    highlights: [
      { icon: 'Inbox',     text: 'Invia un DDT direttamente a un\'altra azienda registrata: nel suo account diventa un DDT di Acquisto con un click.' },
      { icon: 'Smartphone',text: 'DDT Manager è ora installabile come app sul telefono (PWA) con icona in home e modalità offline di base.' },
      { icon: 'ShieldCheck', text: 'Sessione estesa a 30 giorni con refresh silenzioso: niente più logout a sorpresa mentre modifichi un DDT.' },
      { icon: 'Palette',   text: 'Nuova schermata di login con sfondo animato e look moderno.' },
    ],
  },
  {
    version: '1.3.0',
    date: '15 Gennaio 2026',
    title: 'Finanze + Preventivi',
    highlights: [
      { icon: 'TrendingUp',    text: 'Grafico mensile Entrate / Uscite / Guadagni nella Dashboard.' },
      { icon: 'ArrowDownToLine',text: 'Nuova sezione "Entrate" per registrare incassi extra oltre ai DDT.' },
      { icon: 'Wallet',        text: 'Sezione "Uscite" con possibilità di modificare le spese già inserite.' },
      { icon: 'FileSpreadsheet', text: 'Preventivi con nome personalizzato e stampa in PDF.' },
      { icon: 'KeyRound',      text: 'Il super admin può generare una password casuale sicura per ogni azienda e operatore.' },
    ],
  },
];
